import { useEffect, useState } from 'react';
import { ReaderIcon } from '@radix-ui/react-icons';
import type { EbookClient } from '../services/ebooks';

export function EbookShelfCover({
  client,
  path,
  title,
  onImageLoad,
}: {
  client: EbookClient;
  path: string | null;
  title: string;
  onImageLoad?(image: HTMLImageElement): void;
}) {
  const [image, setImage] = useState<{ path: string; url: string } | null>(null);
  const [failed, setFailed] = useState(false);
  useEffect(() => {
    let active = true;
    let url: string | undefined;
    setFailed(false);
    if (path)
      void client
        .coverImage(path)
        .then((blob) => {
          if (!active) return;
          url = URL.createObjectURL(blob);
          setImage({ path, url });
        })
        .catch(() => {
          if (active) setFailed(true);
        });
    return () => {
      active = false;
      if (url) URL.revokeObjectURL(url);
    };
  }, [client, path]);
  const source = !failed && image?.path === path ? image?.url : undefined;
  return (
    <div className={`ebook-shelf-cover${source ? ' has-image' : ''}`}>
      {source ? (
        <img
          src={source}
          alt={`${title}封面`}
          decoding="async"
          onLoad={(event) => onImageLoad?.(event.currentTarget)}
          onError={() => setFailed(true)}
        />
      ) : (
        <>
          <ReaderIcon aria-hidden="true" />
          <strong>{title || '电子书封面'}</strong>
          <span>{failed ? '封面暂未加载' : '弈时围棋'}</span>
        </>
      )}
    </div>
  );
}
